import {
  EuiContextMenuItem,
  EuiContextMenuPanel,
  EuiPopover,
  htmlIdGenerator,
} from "@inscopix/ideas-eui";
import { useState } from "react";
import { useProjectFolderContext } from "../../pages/gdt/folders/ProjectFoldersProvider";
import { useProjectTablesTableContext } from "components/ProjectTablesTable/provider/ProjectTablesTableProvider";
import { shallow } from "zustand/shallow";
import { ButtonEmptyPermissioned } from "components/ButtonEmptyPermissioned/ButtonEmptyPermissioned";

export const ButtonMoveTables = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const folders = useProjectFolderContext((s) => s.getSortedFolders());
  const visibleSelectedTables = useProjectTablesTableContext(
    (s) => s.getVisibleSelectedTables(),
    shallow,
  );
  const moveSelectedToFolder = useProjectTablesTableContext(
    (s) => s.moveSelectedToFolder,
  );
  const moveSelectedOutOfFolder = useProjectTablesTableContext(
    (s) => s.moveSelectedOutOfFolder,
  );

  const isAnySelectedTableInFolder = visibleSelectedTables.some((table) => {
    return table.folder !== null && table.folder !== undefined;
  });

  const handleMoveSelectedOutOfFolder = () => {
    moveSelectedOutOfFolder();
    setIsPopoverOpen(false);
  };

  const handleMoveSelectedToFolder = (folderId: string) => {
    moveSelectedToFolder(folderId);
    setIsPopoverOpen(false);
  };

  return (
    <EuiPopover
      id={htmlIdGenerator()()}
      button={
        <ButtonEmptyPermissioned
          requiredPermission="edit"
          aria-label="Move"
          iconType="continuityWithin"
          onClick={() => setIsPopoverOpen((isOpen) => !isOpen)}
        >
          Move
        </ButtonEmptyPermissioned>
      }
      isOpen={isPopoverOpen}
      closePopover={() => setIsPopoverOpen(false)}
      anchorPosition="upCenter"
      css={{ textAlign: "center" }}
    >
      <EuiContextMenuPanel>
        <EuiContextMenuItem
          icon="returnKey"
          onClick={handleMoveSelectedOutOfFolder}
          disabled={!isAnySelectedTableInFolder}
        >
          Remove from folder
        </EuiContextMenuItem>
        {[...folders]
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((folder) => (
            <EuiContextMenuItem
              key={folder.id}
              icon="folderOpen"
              onClick={() => {
                handleMoveSelectedToFolder(folder.id);
              }}
            >
              {folder.name}
            </EuiContextMenuItem>
          ))}
      </EuiContextMenuPanel>
    </EuiPopover>
  );
};
